
// import React, { useEffect, useState } from 'react';
// import Image from '../../components/AppImage';
// import Icon from '../../components/AppIcon';
// import ResponsiveTopNavigation from '../../components/navigation/ResponsiveTopNavigation';
// import { base_url } from 'Backend/api';
// import { useNavigate } from 'react-router-dom';

// const FavoritesPage = () => {
//   const [favorites, setFavorites] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchFavorites = async () => {
//       try {
//         setLoading(true);
//         const token = localStorage.getItem("token");

//         const res = await fetch(`${base_url}/api/favorites`, {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             Accept: "application/json",
//           },
//         });

//         const data = await res.json();

//         if (data.status) {

//           const formatted = data.data.map((fav) => ({
//             id: fav.id,
//             slug: fav.store.slug,
//             type: fav.store_type,
//             name: fav.store.name,
//             description: `اقل طلب ${fav.store.minimum_order}`,
//             location: fav.store.full_address || fav.store.address?.full_address,
//             rating: Number(fav.store.rating?.average || 0),
//             reviews: fav.store.rating?.reviews_count || 0,
//             deliveryTime: `${fav.store.delivery?.estimate_minutes} دقيقة`,
//             hours: `${fav.store.delivery?.opens_at} - ${fav.store.delivery?.closes_at}`,
//             image: `${base_url}/storage/app/public/${fav.store.image}`,
//             imageAlt: fav.store.name,
//             discounts: fav.store.offers?.map((offer) => ({
//               text: offer.title,
//               color: fav.store_type === "restaurant" ? "red" : "green",
//             })) || []
//           }));

//           setFavorites(formatted);
//         }

//       } catch (error) {
//         console.error("Error fetching favorites:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchFavorites();
//   }, []);

//   const handleUnfavorite = (id) => setFavorites(favorites?.filter((item) => item?.id !== id));
//   const restaurantItems = favorites?.filter((item) => item?.type === 'restaurant');
//   const marketItems = favorites?.filter((item) => item?.type === 'market');
//   const goToStore = (item) => {
//     if (item.type === "restaurant") {
//       navigate(`/restaurant/${item.slug}`);
//     } else {
//       navigate(`/market/${item.slug}`);
//     }
//   };
//   return (

//     <div className="min-h-screen bg-[#f5f5f5] font-[cairo]" dir="rtl">
//       <ResponsiveTopNavigation />
//       <div className="pt-20 md:pt-24 pb-8 px-3 md:px-4 max-w-4xl mx-auto">
//         {loading && (
//           <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50">
//             <div className="w-14 h-14 border-4 border-red-500 border-t-transparent rounded-full animate-spin"></div>
//           </div>
//         )}
//          {!loading && favorites.length === 0 && (
//     <div className="flex justify-center items-center h-[60vh] text-gray-500 text-lg font-[cairo]">
//       لا يوجد عناصر فى المفضلة حتى الان
//     </div>
//   )}

  

//         {/* Restaurants */}
//         <div className="mb-4">
//           <h1 className="font-[cairo] text-lg md:text-xl font-bold text-[#333333]">المطاعم ({restaurantItems?.length})</h1>
//         </div>

//         <div className="space-y-3 md:space-y-4">
//           {restaurantItems?.map((item) =>
//             <div
//               key={item?.id}
//               onClick={() => goToStore(item)}
//               className="bg-white rounded-2xl overflow-hidden shadow-sm cursor-pointer"
//             >
//               <div className="p-3 md:p-4 flex gap-3 md:gap-4">
//                 <div className="relative flex-shrink-0">
//                   <div className="w-16 h-16 md:w-24 md:h-24 rounded-xl overflow-hidden">
//                     <Image src={item?.image} alt={item?.imageAlt} className="w-full h-full object-cover" />
//                   </div>
//                   <button onClick={() => handleUnfavorite(item?.id)}
//                     className="absolute -top-2 -right-2 w-7 h-7 md:w-8 md:h-8 bg-white rounded-full shadow-md flex items-center justify-center hover:scale-110 transition-transform">
//                     <Icon name="Heart" size={14} color="#FF4500" fill="#FF4500" />
//                   </button>
//                 </div>

//                 <div className="flex-1">
//                   <div className="mb-2 md:mb-3">
//                     <p className="text-xs md:text-sm text-[#999999] mb-1">{item?.name}</p>
//                     <p className="text-sm md:text-base font-bold text-[#333333] mb-2">{item?.description}</p>
//                     <div className="flex items-start gap-1">
//                       <Icon name="MapPin" size={12} md-size={14} color="#FF4500" className="mt-0.5 flex-shrink-0" />
//                       <p className="text-xs md:text-sm text-[#666666]">{item?.location}</p>
//                     </div>
//                   </div>

//                   <div className="flex flex-col sm:flex-row gap-1 md:gap-2 flex-wrap">
//                     {item?.discounts?.map((discount, index) =>
//                       <div key={index}
//                         className={`flex items-center gap-1 md:gap-2 px-2 md:px-3 py-1 md:py-2 rounded-lg ${discount?.color === 'red' ? 'bg-[#FF4500]' : 'bg-[#4CAF50]'} text-white`}>
//                         <img src="/assets/images/lo.svg" alt="خصم" className="w-3 h-3 md:w-4 md:h-4 object-contain" />
//                         <span className="text-[9px] md:text-xs font-bold">{discount?.text}</span>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Markets */}
//           {marketItems?.length > 0 &&
//             <>
//               <div className="py-3 md:py-4">
//                 <h2 className="font-[cairo] text-lg md:text-xl font-bold text-[#333333]">ماركت ({marketItems?.length})</h2>
//               </div>

//               {marketItems?.map((item) =>
//                 <div
//                   key={item?.id}
//                   onClick={() => goToStore(item)}
//                   className="bg-white rounded-2xl overflow-hidden shadow-sm cursor-pointer"
//                 >
//                   <div className="p-3 md:p-4 flex gap-3 md:gap-4">
//                     <div className="relative flex-shrink-0">
//                       <div className="w-16 h-16 md:w-24 md:h-24 rounded-xl overflow-hidden">
//                         <Image src={item?.image} alt={item?.imageAlt} className="w-full h-full object-cover" />
//                       </div>
//                       <button onClick={() => handleUnfavorite(item?.id)}
//                         className="absolute -top-2 -right-2 w-7 h-7 md:w-8 md:h-8 bg-white rounded-full shadow-md flex items-center justify-center hover:scale-110 transition-transform">
//                         <Icon name="Heart" size={14} color="#FF4500" fill="#FF4500" />
//                       </button>
//                     </div>

//                     <div className="flex-1">
//                       <div className="mb-2 md:mb-3">
//                         <p className="text-xs md:text-sm text-[#999999] mb-1">{item?.name}</p>
//                         <p className="text-sm md:text-base font-bold text-[#333333] mb-2">{item?.description}</p>
//                         <div className="flex items-start gap-1">
//                           <Icon name="MapPin" size={12} color="#4CAF50" className="mt-0.5 flex-shrink-0" />
//                           <p className="text-xs md:text-sm text-[#666666]">{item?.location}</p>
//                         </div>
//                       </div>

//                       <div className="flex flex-col sm:flex-row gap-1 md:gap-2 flex-wrap">
//                         {item?.discounts?.map((discount, index) =>
//                           <div key={index}
//                             className={`flex items-center gap-1 md:gap-2 px-2 md:px-3 py-1 md:py-2 rounded-lg ${discount?.color === 'red' ? 'bg-[#FF4500]' : 'bg-[#4CAF50]'} text-white`}>
//                             <img src="/assets/images/lo.svg" alt="خصم" className="w-3 h-3 md:w-4 md:h-4 object-contain" />
//                             <span className="text-[9px] md:text-xs font-bold">{discount?.text}</span>
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </>
//           }
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FavoritesPage;
import React, { useEffect, useState } from 'react';
import Image from '../../components/AppImage';
import Icon from '../../components/AppIcon';
import ResponsiveTopNavigation from '../../components/navigation/ResponsiveTopNavigation';
import { base_url } from 'Backend/api';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import AppSpinner from 'components/ui/AppSpinner';
import toast from 'react-hot-toast';
import FavoriteToggleDialog, {
  useFavoriteToggleDialog,
} from 'components/favorites/FavoriteToggleDialog';
import { resolveFavoriteOrdersCount } from '../../utils/storeOrdersCount';
import { enrichFavoriteStoresWithDetails } from '../../utils/enrichFavoriteStoresWithDetails';

const resolveFavoriteImage = (store) => {
  const raw = store?.image_url || store?.image || "";
  const normalized = String(raw).replace(/^\/+/, "");
  if (!normalized) return "/assets/images/logo.jpeg";
  if (String(raw).startsWith("http")) return raw;
  if (store?.image_url) return `${base_url}/${normalized}`;
  return `${base_url}/storage/app/public/${normalized}`;
};

const dedupeFavorites = (items) => {
  if (!Array.isArray(items)) return [];

  const seen = new Set();
  return items.filter((item) => {
    const key = `${item?.store_type || "unknown"}::${item?.store?.slug || item?.id || ""}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

const FavoritesPage = () => {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [togglingKey, setTogglingKey] = useState(null);
  const navigate = useNavigate();
  const { showDialog, dialogMessage, showFavoriteDialog } =
    useFavoriteToggleDialog();

  useEffect(() => {
    const fetchFavorites = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");

        const res = await fetch(`${base_url}/api/favorites`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        const data = await res.json();

        if (data.status) {
          const raw = dedupeFavorites(data.data);
          const enriched = await enrichFavoriteStoresWithDetails(raw, token);
          setFavorites(enriched);
        }

      } catch (error) {
        console.error("Error fetching favorites:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFavorites();
  }, []);

  const restaurantItems = favorites?.filter((item) => item?.store_type === 'restaurant');
  const marketItems = favorites?.filter((item) => item?.store_type === 'market');

  const handleToggleFavorite = async (favoriteItem) => {
    const store = favoriteItem?.store || {};
    const storeSlug = store?.slug;
    const storeType = favoriteItem?.store_type;
    const itemKey = `${storeType}-${favoriteItem?.id}`;

    if (!storeSlug || !storeType) return;

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("يجب تسجيل الدخول أولاً");
        return;
      }

      setTogglingKey(itemKey);

      const endpoint =
        storeType === "restaurant"
          ? `${base_url}/api/favorites/restaurants/${storeSlug}`
          : `${base_url}/api/favorites/markets/${storeSlug}`;

      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json().catch(() => ({}));
      if (!response.ok || result.status === false) {
        toast.error(result.message || "حدث خطأ");
        return;
      }

      setFavorites((prev) =>
        prev.filter(
          (entry) =>
            !(
              entry?.store_type === storeType &&
              entry?.store?.slug === storeSlug
            )
        )
      );

      showFavoriteDialog(false);
    } catch (error) {
      console.error("Error toggling favorite:", error);
      toast.error("حدث خطأ في الشبكة");
    } finally {
      setTogglingKey(null);
    }
  };

  const goToStore = (favoriteItem) => {
    const slug = favoriteItem?.store?.slug;
    if (!slug) return;
    if (favoriteItem?.store_type === "restaurant") {
      navigate(`/restaurant/${slug}`, {
        state: { isFavorite: true },
      });
    } else {
      navigate(`/market/${slug}`, {
        state: { isFavorite: true },
      });
    }
  };

  return (
    <>
     <Helmet>
            <title>المفضلة - يسلمو</title>
          </Helmet>
  

    <div className="min-h-screen bg-gray-50 font-[cairo]" dir="rtl">
      <ResponsiveTopNavigation />

      <div className="pt-20 md:pt-24 pb-8 px-3 md:px-4 max-w-4xl mx-auto">

        {loading && (
          <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50">
            <AppSpinner />
          </div>
        )}

        {!loading && favorites.length === 0 && (
          <div className="flex flex-col items-center justify-center h-[70vh] text-gray-500 font-[cairo]">
            <div className=" flex items-center justify-center ">
             <img src="/assets/images/favNo.svg" alt="heartOff" className="w-40 h-40" />
            </div>
            <p className="text-[14px] font-[cairo] text-[#6B7280]">لا يوجد عناصر في المفضلة حتى الآن</p>
          </div>
        )}

        {!loading && favorites.length > 0 && (
          <>
            {/* Restaurants */}
            <div className="mb-2">
              <h1 className="text-[14px] md:text-[16px] lg:text-[18px] font-bold text-foreground font-[cairo]">
                المطاعم ({restaurantItems?.length})
              </h1>
            </div>

            <div className="space-y-3 md:space-y-4">
              {restaurantItems?.map((item) => {
                const store = item?.store || {};
                const isFavorite = !!(store?.is_favorite ?? true);
                const isToggling = togglingKey === `restaurant-${item?.id}`;
                return (
                <div
                  key={item?.id}
                  onClick={() => goToStore(item)}
                  dir="ltr"
                  className="bg-white rounded-[6px] border border-[#ECECEC] overflow-hidden cursor-pointer p-3"
                >
                  <div className="flex gap-3">
                    <div className="w-[76px] shrink-0 text-[12px]">
                      <div className="inline-flex items-center gap-1 rounded-full bg-[#00B200] px-2 py-0.5 text-white">
                        <span>{store?.rating?.average ?? "0.0"}</span>
                        <span>({store?.rating?.reviews_count ?? 0})</span>
                        <Icon name="Star" size={11} color="#FFCF33" fill="#FFCF33" />
                      </div>
                      <div className="mt-2 text-[#F93209] flex flex-col items-start gap-1" dir="ltr">
                        <span dir="rtl">{store?.delivery?.estimate_minutes ?? "—"} دقيقة</span>
                        <div dir="rtl" className="flex items-center gap-1">
                          <img src="/assets/images/bbagg.svg" className="h-3 w-3" alt="" />
                          <span>{resolveFavoriteOrdersCount(store, "restaurant")} طلب</span>
                        </div>
                      </div>
                    </div>

                    <div dir="rtl" className="min-w-55 flex-1">
                      <h3 className="text-[14px] font-medium text-[#1F2937] -mt-1 line-clamp-1 font-[cairo]">
                        {store?.name}
                      </h3>
                      <div className="text-[11px] text-[#4B5563] mt-1 line-clamp-1">
                        أقل سعر للطلب {store?.minimum_order ?? "—"} ل.س
                      </div>
                      <div className="mt-1 flex items-center gap-1 text-[10px] text-[#6B7280] line-clamp-1">
                        <Icon name="MapPin" size={13} color="#F93209" />
                        {store?.full_address || store?.address?.full_address || "—"}
                      </div>
                    </div>

                    <div className="relative w-[68px] shrink-0 sm:w-[76px]">
                      <div className="h-[68px] w-[68px] overflow-hidden rounded-[6px] sm:h-[76px] sm:w-[76px]">
                        <Image src={resolveFavoriteImage(store)} alt={store?.name || "favorite"} className="w-full h-full object-cover" />
                      </div>

                      <button
                        type="button"
                        disabled={isToggling}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleToggleFavorite(item);
                        }}
                        className="absolute -top-1.5 -right-1.5 flex h-6 w-6 items-center justify-center rounded-full bg-white shadow-md disabled:opacity-60"
                      >
                        <Icon
                          name="Heart"
                          size={13}
                          color="#F93209"
                          fill="#F93209"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              )})}

              {/* Markets */}
              {marketItems?.length > 0 &&
                <>
                  <div className="mb-1">
                    <h2 className="text-[14px] md:text-[16px] lg:text-[18px] font-bold text-foreground font-[cairo]">
                      ماركت ({marketItems?.length})
                    </h2>
                  </div>

                  {marketItems?.map((item) => {
                    const store = item?.store || {};
                    const isToggling = togglingKey === `market-${item?.id}`;
                    return (
                    <div
                      key={item?.id}
                      onClick={() => goToStore(item)}
                      dir="ltr"
                      className="bg-white rounded-[6px] border border-[#ECECEC] overflow-hidden cursor-pointer p-3 "
                    >
                      <div className="flex gap-3">
                        <div className="w-[76px] shrink-0 text-[12px]">
                          <div className="inline-flex items-center gap-1 rounded-full bg-[#00B200] px-2 py-0.5 text-white">
                            <span>{store?.rating?.average ?? "0.0"}</span>
                            <span>({store?.rating?.reviews_count ?? store?.rating?.total_count ?? 0})</span>
                            <Icon name="Star" size={11} color="#FFCF33" fill="#FFCF33" />
                          </div>
                          <div className="mt-2 text-[#00A651] flex flex-col items-start gap-1" dir="ltr">
                            <span dir="rtl">{store?.delivery?.estimate_minutes ?? "—"} دقيقة</span>
                            <div dir="rtl" className="flex items-center gap-1">
                              <img src="/assets/images/bbagg.svg" className="h-3 w-3" alt="" />
                              <span>{resolveFavoriteOrdersCount(store, "market")} طلب</span>
                            </div>
                          </div>
                        </div>

                        <div dir="rtl" className="min-w-55 flex-1">
                          <h3 className="text-[14px] font-medium text-[#1F2937] -mt-1 line-clamp-1 font-[cairo]">
                            {store?.name}
                          </h3>
                          <div className="text-[11px] text-[#4B5563] mt-1 line-clamp-1">
                            أقل سعر للطلب {store?.minimum_order ?? "—"} ل.س
                          </div>
                          <div className="mt-1 flex items-center gap-1 text-[10px] text-[#6B7280] line-clamp-1">
                            <Icon name="MapPin" size={13} color="#00B200" />
                            {store?.full_address || store?.address?.full_address || "—"}
                          </div>
                        </div>

                        <div className="relative w-[68px] shrink-0 sm:w-[76px]">
                          <div className="h-[68px] w-[68px] overflow-hidden rounded-[6px] sm:h-[76px] sm:w-[76px]">
                            <Image src={resolveFavoriteImage(store)} alt={store?.name || "favorite"} className="w-full h-full object-cover" />
                          </div>

                          <button
                            type="button"
                            disabled={isToggling}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleToggleFavorite(item);
                            }}
                            className="absolute -top-1.5 -right-1.5 flex h-6 w-6 items-center justify-center rounded-full bg-white shadow-md disabled:opacity-60"
                          >
                            <Icon
                              name="Heart"
                              size={13}
                              color="#00B200"
                              fill="#00B200"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  )})}
                </>
              }
            </div>
          </>
        )}

      </div>
      <FavoriteToggleDialog open={showDialog} message={dialogMessage} />
    </div>
      </>
  );
};

export default FavoritesPage;